// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttonIncluir-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.buttonIncluir-button {\n  margin-bottom: 15px !important;\n}\n.buttonIncluir-button + .buttonIncluir-button {\n  margin-left: 5px !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
